const isDevEnvironment = process.env.NODE_ENV !== 'production'

export const logger = {
	log: (...args) => {
		if (isDevEnvironment) {
			console.log(...args)
		}
	},
	warn: (...args) => {
		if (isDevEnvironment) {
			console.warn(...args)
		}
	},
	error: (...args) => {
		console.error(...args)
	},
}

export const createScopedLogger = scope => ({
	log: (...args) => logger.log(`[${scope}]`, ...args),
	warn: (...args) => logger.warn(`[${scope}]`, ...args),
	error: (...args) => logger.error(`[${scope}]`, ...args),
})
